import React from 'react';
import useWindowDimensions from './hooks/useWindowDimensions';
import DesktopComponents from './Components/DesktopComponents/DesktopComponents';
import MobileComponents from './Components/MobileComponents/MobileComponents';
import TabletComponents from './Components/TabletComponents/TabletComponents';
const App = () => {
  const { height, width } = useWindowDimensions();
  return (
    <main className='w-full min-h-screen'>
      {width >= 1024 && <DesktopComponents />}
      {width >= 500 && width < 1024 && <MobileComponents />}
      {width < 500 && <MobileComponents />}
    </main>
  );
}

export default App;
